import React from 'react'

import { Loading } from '../../../global/Loading/Loading'
import IconButton from '../../../global/iconButton/IconButton'
import { CloseIcon } from '../../../icons/CloseIcon'
import { TextLargeStrong } from '../../Typography/Typography'
import { ModalMobile } from '../../v2/Modal/ModalMobile'
import { ModalTitle } from '../../v2/Modal/common/components/ModalTitle'
import { CommonModalProps } from '../../v2/Modal/types'

import styles from './InfoCardModal.module.scss'

export interface ExpandableModalProps extends CommonModalProps {
  renderFooter?(props: ExpandableModalProps): React.ReactNode[]
  goBack?(): void
}

export const InfoCardModal: React.FC<ExpandableModalProps> = (props) => {
  const { onClose } = props

  const handleClose = async () => {
    onClose?.()
  }

  return (
    <ModalMobile onClose={handleClose}>
      <ModalBody {...props} onClose={handleClose} />
    </ModalMobile>
  )
}

const ModalBody: React.FC<ExpandableModalProps> = (props) => {
  const { children, isLoading = false, onClose, title } = props

  return (
    <div className={styles.modal}>
      <div className={styles.wrapper}>
        <ModalHeader {...props} />
        <section className={styles.body}>
          <div className={styles.content}>
            <div className={styles.scrollContainer}>
              <Loading isLoading={isLoading} showLoadingIcon wrapperClass={styles.loading}>
                {children}
              </Loading>
            </div>
            {!title && (
              <IconButton onClick={onClose} className={styles.closeButton}>
                <CloseIcon />
              </IconButton>
            )}
          </div>
        </section>
      </div>
    </div>
  )
}

const ModalHeader: React.FC<ExpandableModalProps> = (props) => {
  const { title, isLoading = false, onClose } = props

  if (!title) {
    return null
  }

  return (
    <header className={styles.header}>
      {!isLoading && (
        <div className={styles.titleWrapper}>
          <TextLargeStrong className={styles.title}>
            <span className={styles.titleText}>
              <ModalTitle title={title} />
            </span>
            <IconButton onClick={onClose}>
              <CloseIcon />
            </IconButton>
          </TextLargeStrong>
        </div>
      )}
    </header>
  )
}
